<template>
    <div v-show="isOpen" :class="customClass">
        <slot></slot>
    </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-dropdown-menu')
export default class VrmDropdownMenu extends Vue {
    @Prop({ type: String, default: null })
    customClass;
    @Prop({ type: Boolean, required: true })
    isOpen;

    mounted() {
        document.addEventListener('click', this.checkOutsideClick);
    }

    beforeDestroy() {
        document.removeEventListener('click', this.checkOutsideClick);
    }

    checkOutsideClick(e) {
        if (
            this.isOpen &&
            !this.$el.contains(e.target) &&
            (typeof e.target.parentElement.className !== 'string' ||
                !e.target.parentElement.className.startsWith('air-datepicker'))
        ) {
            this.handleClose();
        }
    }

    handleClose() {
        this.$emit('close');
    }
}
</script>
